export default "__VITE_ASSET__B5U1Swkj__"